import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { isMobile } from 'react-device-detect';

import { translate } from 'services/i18nService';
import routeDefinitions from 'enum/routeDefinitions';
import { generateID } from 'utils/helpers';

import errorUnplug from '../../../images/error-unplug.png';

import styles from './ErrorHandler.css';


const MOBILE_IMAGE_DEFAULT_HEIGHT = 80;

function ErrorHandler({ bigTitle, errorStatus, maxWidth, isButtonVisible, imgHeight }) {
  const IDS = {
    prefix: 't1RL3gGV',
    element: 'linkBackToHome',
  };

  const makeId = generateID(IDS.prefix, IDS.element);

  return (
    <div className={styles.container} style={{ maxWidth }}>
      <Typography classes={{ h3: styles.h3 }} variant="h3">
        {errorStatus || translate('strings.strings.error', { 0: 500 })}
      </Typography>
      <Typography classes={{ h6: styles.h6 }} variant="h6">
        {bigTitle || translate('strings.strings.something.went.wrong')}
      </Typography>
      <figure>
        <img
          alt={errorUnplug}
          height={isMobile ? MOBILE_IMAGE_DEFAULT_HEIGHT : imgHeight}
          src={errorUnplug}
        />
      </figure>
      <Typography classes={{ body1: styles.body }}>
        {translate('strings.strings.error.occurred', {
          0: '<strong>',
          1: '</strong>',
          2: `<a href=${routeDefinitions.contact}>`,
          3: '</a>',
        })}
      </Typography>
      {isButtonVisible && (
        <a
          className={styles.backToHome}
          href={routeDefinitions.root}
          id={makeId(IDS.element)}
        >
          {translate('strings.pagenotfound.buttonlabel')}
        </a>
      )}
    </div>
  );
}

ErrorHandler.propTypes = {
  bigTitle: PropTypes.string,
  errorStatus: PropTypes.node,
  imgHeight: PropTypes.number,
  isButtonVisible: PropTypes.bool,
  maxWidth: PropTypes.number,
};

ErrorHandler.defaultProps = {
  bigTitle: undefined,
  errorStatus: undefined,
  imgHeight: 180,
  isButtonVisible: false,
  maxWidth: 600,
};

export default ErrorHandler;
